const initialState = {
    list : [],
    loading : true,
    error: false,
    is_login: false,
};
function dashboardsReducer(state = initialState, action) {
    switch (action.type) {
        case 'LOAD_DASHBOARDS':
            return { ...state, list:[], error: false, loading: true }
        case 'GET_DASHBOARDS':
            return { ...state, list: action.payload, error: false, loading: false }
        case 'ADD_TOKEN':
            return { ...state, list: [...state.list, action.payload], error: false, loading: false }
        case 'ERROR_DASHBOARDS':
            return { ...state, list: [], error: true, loading: false }
        case 'MAKE_LOGOUT':
            return { ...state, is_login:false}
        case 'MAKE_LOGIN':
            return { ...state, is_login:true}
        default:
            return state;
    }
};
export default dashboardsReducer;